import { render } from "./TicketBooking.vue?vue&type=template&id=083bb175&scoped=true"
import script from "./TicketBooking.vue?vue&type=script&lang=js"
export * from "./TicketBooking.vue?vue&type=script&lang=js"

import "./TicketBooking.vue?vue&type=style&index=0&id=083bb175&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083bb175"]])

export default __exports__